export default "__VITE_ASSET__$lMfWeUJ__"